var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "item" }, [
    _c("div", { staticClass: "quantity" }, [
      _c(
        "a",
        {
          staticClass: "change",
          on: {
            click: function($event) {
              return _vm.change("subtract")
            }
          }
        },
        [_vm._v("-")]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "amount",
        domProps: { textContent: _vm._s(_vm.quantity) }
      }),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "change",
          on: {
            click: function($event) {
              return _vm.change("add")
            }
          }
        },
        [_vm._v("+")]
      )
    ]),
    _vm._v(" "),
    _c("div", { domProps: { textContent: _vm._s(_vm.title) } }),
    _vm._v(" "),
    _c("div", [_vm._v(_vm._s(_vm.price / 100))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }